<template>
  <div class="tl">
    <Breadcrumbs main="Пользователи" title="Реальные пользователи"/>

    <Modal name="BanUser" title="Бан пользователя" v-model="isShowBanUserModal"
           :params="{ id: selectedUserId }" @submit="onBanSuccess"/>

    <div class="container-fluid tl-container">

      <!-- ================== TOOLBAR ================== -->
      <div class="tl-toolbar">
        <div class="tl-toolbar__main">
          <div class="tl-search" :class="{ 'is-busy': isLoadingUsers }">
            <i class="fa fa-search tl-search__icon"></i>
            <input
                ref="search"
                type="search"
                class="tl-search__input"
                v-model="searchModel"
                :placeholder="searchPlaceholder"
                @keydown.esc.prevent="clearSearch"
            />
            <button v-if="searchModel" type="button" class="tl-search__clear" @click="clearSearch">
              <i class="fa fa-times"></i>
            </button>
            <kbd v-else class="tl-search__kbd">/</kbd>
          </div>

          <b-dropdown variant="link" class="tl-drop" no-caret menu-class="tl-drop__menu">
            <template #button-content>
              <span class="tl-drop__btn is-on">
                <i class="fa fa-crosshairs"></i>
                <span class="tl-drop__btn-text">{{ searchFieldLabel }}</span>
                <i class="fa fa-angle-down"></i>
              </span>
            </template>
            <b-dropdown-item v-for="option in searchFieldOptions" :key="option.value"
                             @click="setSearchField(option.value)">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': searchField !== option.value }"></i>
              {{ option.text }}
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown variant="link" class="tl-drop" no-caret menu-class="tl-drop__menu">
            <template #button-content>
              <span class="tl-drop__btn" :class="{ 'is-on': refine !== 'all' }">
                <i class="fa fa-filter"></i>
                <span class="tl-drop__btn-text">{{ refineLabel }}</span>
                <i class="fa fa-angle-down"></i>
              </span>
            </template>
            <b-dropdown-item @click="refine = 'all'">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': refine !== 'all' }"></i> Все пользователи
            </b-dropdown-item>
            <b-dropdown-item @click="refine = 'banned'">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': refine !== 'banned' }"></i> Забаненные
            </b-dropdown-item>
            <b-dropdown-item @click="refine = 'gamer'">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': refine !== 'gamer' }"></i> С игровым профилем
            </b-dropdown-item>
            <b-dropdown-item @click="refine = 'notActivated'">
              <i class="fa fa-check tl-drop__check" :class="{ 'is-hidden': refine !== 'notActivated' }"></i> Без соц. аккаунта
            </b-dropdown-item>
          </b-dropdown>

          <div class="tl-spacer"></div>

          <div class="tl-seg" role="group" aria-label="Вид">
            <button type="button" class="tl-seg__btn" :class="{ 'is-on': viewMode === 'table' }"
                    @click="setViewMode('table')" v-b-tooltip.hover.bottom="'Таблица'">
              <i class="fa fa-list-ul"></i>
            </button>
            <button type="button" class="tl-seg__btn" :class="{ 'is-on': viewMode === 'grid' }"
                    @click="setViewMode('grid')" v-b-tooltip.hover.bottom="'Карточки'">
              <i class="fa fa-th-large"></i>
            </button>
          </div>

          <button type="button" class="tl-icon-btn" :class="{ 'is-on': density === 'compact' }"
                  @click="toggleDensity" v-b-tooltip.hover.bottom="'Плотность строк'">
            <i class="fa fa-bars"></i>
          </button>

          <b-dropdown variant="link" class="tl-drop" no-caret right menu-class="tl-drop__menu" toggle-class="p-0">
            <template #button-content>
              <span class="tl-icon-btn" v-b-tooltip.hover.bottom="'Другие разделы'"><i class="fa fa-ellipsis-h"></i></span>
            </template>
            <b-dropdown-item :to="{ name: 'users_levels' }">
              <i class="fa fa-signal tl-drop__check"></i> Уровни и опыт
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'user_login_logs' }">
              <i class="fa fa-sign-in tl-drop__check"></i> Логи авторизации
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'users_transfer_logs' }">
              <i class="fa fa-exchange tl-drop__check"></i> Трансферы
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'users_fake' }">
              <i class="fa fa-user-secret tl-drop__check"></i> Фейковые пользователи
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ban_users' }">
              <i class="fa fa-ban tl-drop__check"></i> Забаненные пользователи
            </b-dropdown-item>
          </b-dropdown>

          <button type="button" class="tl-icon-btn" :class="{ 'is-spin': isLoadingUsers }"
                  @click="refresh" v-b-tooltip.hover.bottom="'Обновить'">
            <i class="fa fa-refresh"></i>
          </button>
        </div>

        <div v-if="hasAnyRefine" class="tl-chips">
          <span class="tl-chips__label">Фильтры:</span>

          <button v-if="searchApplied" type="button" class="tl-chip" @click="clearSearch">
            <i class="fa fa-search"></i> {{ searchFieldLabel }}: «{{ searchApplied }}»
            <i class="fa fa-times tl-chip__x"></i>
          </button>

          <button v-if="refine !== 'all'" type="button" class="tl-chip tl-chip--local" @click="refine = 'all'">
            <i class="fa fa-filter"></i> {{ refineLabel }}
            <span class="tl-chip__hint">на странице</span>
            <i class="fa fa-times tl-chip__x"></i>
          </button>

          <button type="button" class="tl-chips__reset" @click="resetAll">Сбросить всё</button>
        </div>
      </div>

      <!-- ================== CONTENT ================== -->
      <div class="tl-panel" :class="['tl-panel--' + density]">

        <div v-if="isLoadingUsers" class="tl-skeleton">
          <div v-for="n in 8" :key="'sk' + n" class="tl-skeleton__row">
            <span class="tl-sk tl-sk--avatar"></span>
            <span class="tl-sk tl-sk--wide"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk tl-sk--sm"></span>
          </div>
        </div>

        <div v-else-if="!rows.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-user-o"></i></div>
          <div class="tl-empty__title">
            {{ hasAnyRefine ? 'Ничего не нашлось' : 'Пользователей нет' }}
          </div>
          <div class="tl-empty__text">
            {{ hasAnyRefine
              ? 'Проверьте, по какому полю идёт поиск — его можно сменить рядом со строкой поиска.'
              : 'Список пуст.' }}
          </div>
          <div v-if="hasAnyRefine" class="tl-empty__actions">
            <button type="button" class="tl-btn-ghost-2" @click="resetAll">Сбросить фильтры</button>
          </div>
        </div>

        <!-- table -->
        <div v-else-if="viewMode === 'table'" class="tl-table-wrap">
          <b-table
              ref="table"
              class="tl-table"
              responsive
              hover
              borderless
              show-empty
              :items="rows"
              :fields="activeFields"
              :tbody-tr-class="rowClass"
              :sort-by.sync="sortByField"
              :sort-desc.sync="sortDesc"
              no-local-sorting
              @sort-changed="onSortChanged"
              @row-clicked="openUser"
          >
            <template #cell(id)="{ item }">
              <button type="button" class="tl-id" @click.stop="copyValue(item.id, 'ID')"
                      v-b-tooltip.hover.right="'Скопировать ID'">
                <span>#{{ item.id }}</span>
                <i class="fa fa-copy"></i>
              </button>
            </template>

            <template #cell(username)="{ item }">
              <div class="tl-name">
                <span class="tl-name__logo">{{ initials(item.username) }}</span>
                <div class="tl-name__col">
                  <button type="button" class="tl-name__title" @click.stop="openUser(item)" :title="item.username">
                    {{ item.username || '—' }}
                  </button>
                  <div v-if="item.x_banned" class="tl-name__marks">
                    <span class="tl-tag tl-tag--ban"><i class="fa fa-ban"></i> Бан</span>
                  </div>
                </div>
              </div>
            </template>

            <template #cell(email)="{ item }">
              <button v-if="item.email" type="button" class="tl-copy"
                      @click.stop="copyValue(item.email, 'Email')"
                      v-b-tooltip.hover.top="'Скопировать email'">
                {{ item.email }} <i class="fa fa-copy"></i>
              </button>
              <span v-else class="tl-muted">—</span>
            </template>

            <template #cell(status)="{ item }">
              <div class="tl-name__marks">
                <span class="tl-tag" :class="item.x_gamer ? 'tl-tag--ok' : 'tl-tag--muted'">
                  {{ item.x_gamer ? 'Игровой' : 'Не игровой' }}
                </span>
                <span class="tl-tag" :class="item.x_activated ? 'tl-tag--ok' : 'tl-tag--warn'">
                  {{ item.x_activated ? 'Активирован' : 'Не активирован' }}
                </span>
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="tl-actions" @click.stop>
                <button type="button" class="tl-act" @click="openUser(item)"
                        v-b-tooltip.hover.top="'Открыть карточку в новой вкладке'">
                  <i class="fa fa-eye"></i>
                </button>
                <button v-if="item.x_banned" type="button" class="tl-act tl-act--warn"
                        @click="unbanUser(item)" v-b-tooltip.hover.top="'Снять бан'">
                  <i class="fa fa-unlock"></i>
                </button>
                <button v-else type="button" class="tl-act tl-act--danger"
                        @click="openBanModal(item)" v-b-tooltip.hover.top="'Забанить'">
                  <i class="fa fa-ban"></i>
                </button>
              </div>
            </template>

            <template #empty>
              <div class="tl-empty tl-empty--inline">Ничего не найдено</div>
            </template>
          </b-table>
        </div>

        <!-- grid -->
        <div v-else class="tl-grid">
          <article v-for="item in rows" :key="'card' + item.id" class="tl-card" @click="openUser(item)">
            <header class="tl-card__head">
              <span class="tl-card__logo">{{ initials(item.username) }}</span>
              <div class="tl-card__headtext">
                <button type="button" class="tl-card__title" @click.stop="openUser(item)" :title="item.username">
                  {{ item.username || '—' }}
                </button>
                <div class="tl-card__sub">
                  <span class="tl-id tl-id--sm">#{{ item.id }}</span>
                  <span v-if="item.x_banned" class="tl-tag tl-tag--ban"><i class="fa fa-ban"></i> Бан</span>
                </div>
              </div>
            </header>

            <div class="tl-card__rows">
              <div class="tl-card__row">
                <span><i class="fa fa-envelope-o tl-muted"></i> Почта</span>
                <span class="tl-muted-strong">{{ item.email || '—' }}</span>
              </div>
              <div class="tl-card__row">
                <span><i class="fa fa-gamepad tl-muted"></i> Игровой профиль</span>
                <span class="tl-tag" :class="item.x_gamer ? 'tl-tag--ok' : 'tl-tag--muted'">
                  {{ item.x_gamer ? 'есть' : 'нет' }}
                </span>
              </div>
              <div class="tl-card__row">
                <span><i class="fa fa-link tl-muted"></i> Соц. аккаунт</span>
                <span class="tl-tag" :class="item.x_activated ? 'tl-tag--ok' : 'tl-tag--warn'">
                  {{ item.x_activated ? 'активирован' : 'нет' }}
                </span>
              </div>
            </div>

            <footer class="tl-card__foot" @click.stop>
              <button type="button" class="tl-act" @click="openUser(item)" v-b-tooltip.hover.top="'Открыть карточку'">
                <i class="fa fa-eye"></i>
              </button>
              <span class="tl-spacer"></span>
              <button v-if="item.x_banned" type="button" class="tl-act tl-act--warn"
                      @click="unbanUser(item)" v-b-tooltip.hover.top="'Снять бан'">
                <i class="fa fa-unlock"></i>
              </button>
              <button v-else type="button" class="tl-act tl-act--danger"
                      @click="openBanModal(item)" v-b-tooltip.hover.top="'Забанить'">
                <i class="fa fa-ban"></i>
              </button>
            </footer>
          </article>
        </div>

        <div v-if="!isLoadingUsers && rows.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ rangeFrom }}–{{ rangeTo }}</b> из <b>{{ totalUserPagination || 0 }}</b>
            <span v-if="refine !== 'all'" class="tl-muted"> · отфильтровано на странице</span>
          </div>
          <b-pagination
              class="tl-pagination my-0"
              v-model="currentPageModel"
              :total-rows="totalUserPagination"
              :per-page="perPage"
              :limit="7"
              @change="goToPage"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {UsersAdapterMixin} from "../../mixins/Users/UsersAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import {UserBanAdapterMixin} from "@/mixins/UserBan/UserBanAdapterMixin";
import Modal from '@/components/modals/index.vue'

const SORT_FIELD_MAP = {
  id: 'users.id',
  username: 'username',
  email: 'email',
  status: 'role',
};

const SEARCH_FIELD_OPTIONS = [
  {value: 'id', text: 'По ID'},
  {value: 'username', text: 'По username'},
  {value: 'email', text: 'По email'},
  {value: 'teams.name', text: 'По команде'},
  {value: 'game_profile_game_id', text: 'По Game ID (PUBG/MLBB)'},
  {value: 'game_profile_nick', text: 'По игровому нику'},
  {value: 'social_account_username', text: 'По соц. аккаунту'},
];

const SEARCH_PLACEHOLDERS = {
  id: 'Введите ID пользователя…',
  username: 'Введите username…',
  email: 'Введите email…',
  'teams.name': 'Введите название команды…',
  game_profile_game_id: 'Введите PUBG ID или MLBB ID…',
  game_profile_nick: 'Введите игровой ник…',
  social_account_username: 'Введите username соц. аккаунта…',
};

const LS = {
  view: "usersListView",
  density: "usersListDensity",
  columns: "usersListColumns",
};

const ALL_COLUMNS = [
  {key: "id", label: "ID", fixed: true},
  {key: "username", label: "Пользователь", fixed: true},
  {key: "email", label: "Почта"},
  {key: "status", label: "Статус"},
  {key: "action", label: "", fixed: true},
];

const DEFAULT_COLUMNS = ["email", "status"];

export default {
  name: "ListUsers",
  components: {Modal},
  mixins: [UsersAdapterMixin, PaginationHelperMixin, UserBanAdapterMixin],
  data() {
    return {
      pageKey: 'pageNumberUsersList',
      perPage: 10,

      searchModel: '',
      searchApplied: '',
      searchField: 'username',
      searchFieldOptions: SEARCH_FIELD_OPTIONS,
      searchTimer: null,

      refine: 'all',

      sortByField: 'id',
      sortDesc: true,

      viewMode: 'table',
      density: 'cozy',
      visibleCols: [...DEFAULT_COLUMNS],

      isLoadingUsers: false,
      isShowBanUserModal: false,
      selectedUserId: null,
    }
  },
  computed: {
    searchPlaceholder() {
      return SEARCH_PLACEHOLDERS[this.searchField] || 'Поиск пользователей…';
    },

    searchFieldLabel() {
      const option = SEARCH_FIELD_OPTIONS.find(item => item.value === this.searchField);
      return option ? option.text : 'По username';
    },

    refineLabel() {
      if (this.refine === 'banned') return 'Забаненные';
      if (this.refine === 'gamer') return 'С игровым профилем';
      if (this.refine === 'notActivated') return 'Без соц. аккаунта';
      return 'Статус';
    },

    hasAnyRefine() {
      return Boolean(this.searchApplied) || this.refine !== 'all';
    },

    currentSort() {
      const apiField = SORT_FIELD_MAP[this.sortByField] || this.sortByField;
      return this.sortDesc ? `-${apiField}` : apiField;
    },

    rows() {
      const list = (this.users || []).map(user => ({
        ...user,
        x_banned: Boolean(user.currentBans && user.currentBans.length),
        x_banId: user.currentBans && user.currentBans.length ? user.currentBans[0].id : null,
        x_gamer: (user.game_profiles_count || 0) > 0,
        x_activated: (user.verified_social_accounts_count || 0) > 0,
      }));

      if (this.refine === 'banned') return list.filter(user => user.x_banned);
      if (this.refine === 'gamer') return list.filter(user => user.x_gamer);
      if (this.refine === 'notActivated') return list.filter(user => !user.x_activated);
      return list;
    },

    togglableColumns() {
      return ALL_COLUMNS.filter(col => !col.fixed);
    },

    activeFields() {
      return ALL_COLUMNS
          .filter(col => col.fixed || this.visibleCols.includes(col.key))
          .map(col => ({
            key: col.key,
            label: col.label,
            sortable: !["action"].includes(col.key),
            thClass: col.key === "action" ? "tl-th--act" : "",
            tdClass: col.key === "action" ? "tl-td--act" : "",
          }));
    },

    currentPageModel: {
      get() {
        return Number(this.currentPage) || 1;
      },
      set(value) {
        this.currentPage = value;
      },
    },

    rangeFrom() {
      if (!this.totalUserPagination) return 0;
      return (this.currentPageModel - 1) * this.perPage + 1;
    },

    rangeTo() {
      return Math.min(this.currentPageModel * this.perPage, this.totalUserPagination || 0);
    },
  },
  watch: {
    searchModel(value) {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (this.searchApplied === value.trim()) return;
        this.searchApplied = value.trim();
        this.currentPage = 1;
        this.fetchUsers();
      }, 400);
    },
  },
  mounted() {
    this.restorePreferences();
    this.currentPage = Number(this.getCurrentPageNumber(this.pageKey)) || 1;
    this.fetchUsers();
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  methods: {
    async fetchUsers() {
      this.isLoadingUsers = true;
      this.recordPageToStorage(this.currentPageModel, this.pageKey);
      const params = {
        pageNumber: this.currentPageModel,
        filters: {},
        sort: this.currentSort,
      };
      if (this.searchApplied) params.filters[this.searchField] = this.searchApplied;
      try {
        await this.grabUsers(params);
      } catch (e) {
        this.$toasted.error("Не удалось загрузить пользователей", {position: 'top-right', duration: 3000});
      } finally {
        this.isLoadingUsers = false;
      }
    },

    refresh() {
      this.fetchUsers();
    },

    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.$nextTick(this.fetchUsers);
    },

    setSearchField(field) {
      this.searchField = field;
      if (!this.searchApplied) return;
      this.currentPage = 1;
      this.fetchUsers();
    },

    clearSearch() {
      this.searchModel = '';
      if (!this.searchApplied) return;
      this.searchApplied = '';
      this.currentPage = 1;
      this.fetchUsers();
    },

    resetAll() {
      this.searchModel = '';
      this.searchApplied = '';
      this.refine = 'all';
      this.currentPage = 1;
      this.fetchUsers();
    },

    onSortChanged(ctx) {
      this.sortByField = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.currentPage = 1;
      this.fetchUsers();
    },

    openUser(item) {
      this.showUserInfo(item.id);
    },

    openBanModal(item) {
      this.selectedUserId = item.id;
      this.isShowBanUserModal = true;
    },

    async unbanUser(item) {
      if (!item.x_banId) return;
      await this.deleteUserBan({userId: item.x_banId});
      this.$toasted.success(`Бан с «${item.username}» снят`, {position: 'top-right', duration: 2500});
      this.fetchUsers();
    },

    onBanSuccess() {
      this.fetchUsers();
    },

    copyValue(value, label) {
      const text = String(value);
      const done = () => this.$toasted.success(`${label} скопирован`, {position: 'top-right', duration: 1500});
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {
        });
        return;
      }
      const area = document.createElement("textarea");
      area.value = text;
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand("copy");
        done();
      } finally {
        document.body.removeChild(area);
      }
    },

    restorePreferences() {
      try {
        const view = localStorage.getItem(LS.view);
        if (view === "grid" || view === "table") this.viewMode = view;

        const density = localStorage.getItem(LS.density);
        if (density === "compact" || density === "cozy") this.density = density;

        const columns = JSON.parse(localStorage.getItem(LS.columns) || "null");
        if (Array.isArray(columns)) this.visibleCols = columns;
      } catch (e) { /* повреждённые настройки — берём значения по умолчанию */
      }
    },

    setViewMode(mode) {
      this.viewMode = mode;
      localStorage.setItem(LS.view, mode);
    },

    toggleDensity() {
      this.density = this.density === "compact" ? "cozy" : "compact";
      localStorage.setItem(LS.density, this.density);
    },

    rowClass(item) {
      return item && item.x_banned ? "tl-row--banned" : "";
    },

    initials(name) {
      if (!name) return "?";
      return String(name).trim().slice(0, 2).toUpperCase();
    },

    onKeydown(event) {
      const tag = (event.target && event.target.tagName) || "";
      const isTyping = /INPUT|TEXTAREA|SELECT/.test(tag) || (event.target && event.target.isContentEditable);

      if (event.key === "Escape") {
        if (isTyping) return;
        if (this.hasAnyRefine) this.resetAll();
        return;
      }

      if (isTyping || event.ctrlKey || event.metaKey || event.altKey) return;

      if (event.key === "/") {
        event.preventDefault();
        if (this.$refs.search) this.$refs.search.focus();
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";

.tl-name__col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.tl-name__title,
.tl-card__title {
  border: 0;
  background: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.tl-name__logo,
.tl-card__logo {
  font-weight: 700;
  font-size: 12px;
}

.tl-name__marks {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.tl-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;

  &--ok { background: rgba(47, 179, 68, .14); color: #1f8c33; }
  &--warn { background: rgba(240, 160, 32, .16); color: #a86c0d; }
  &--muted { background: var(--tl-soft-2); color: var(--tl-muted); }
  &--ban { background: var(--tl-danger); color: #fff; }
}

.tl-copy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: none;
  padding: 0;
  color: var(--tl-text);
  font-size: 13px;
  cursor: pointer;

  i { opacity: 0; font-size: 10px; transition: opacity .14s ease; }

  &:hover {
    color: var(--tl-primary);

    i { opacity: 1; }
  }
}

.tl-table ::v-deep tbody tr.tl-row--banned td {
  background: rgba(224, 65, 79, .05);
}

.tl-table ::v-deep tbody tr.tl-row--banned:hover td {
  background: rgba(224, 65, 79, .09);
}
</style>
